<template>
  <div class="content">
    <div class="holder container">
      <div class="message-term">
        <p v-html="$t('front_end.a030.term')"></p>
      </div>
      <div class="content-body col-md-8 col-lg-7 col-11 p-0">
        <div class="scroll-box">
          <div class="scroll-box-inner">
            <div class="policy policya030">
              <p v-html="rawTerms"></p>
            </div>
            <div class="policy" v-show="false">
              <h5
                id="policy-01"
                class="policy-text-title"
              >{{$t('front_end.a030.content.policy_one')}}</h5>
              <ol class="policy-list-lv-1">
                <li>{{$t('front_end.a030.content.policy_one_one')}}</li>
                <p class="mb-0">{{$t('front_end.a030.content.policy_one_one_br_a')}}</p>
                <p class="mb-0">{{$t('front_end.a030.content.policy_one_one_br_b')}}</p>
                <p class="mb-0">{{$t('front_end.a030.content.policy_one_one_br_c')}}</p>
              </ol>
              <h5
                id="policy-02"
                class="policy-text-title"
              >{{$t('front_end.a030.content.policy_two')}}</h5>
              <ol class="policy-list-lv-1">
                <li>
                  {{$t('front_end.a030.content.policy_two_one')}}
                  <ol class="policy-list-lv-2">
                    <li>
                      <span>{{$t('front_end.a030.content.policy_two_one_one_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_two_one_one')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_two_one_two_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_two_one_two')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_two_one_three_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_two_one_three')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_two_one_four_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_two_one_four')}}</span>
                    </li>
                  </ol>
                </li>
              </ol>

              <h5
                id="policy-03"
                class="policy-text-title"
              >{{$t('front_end.a030.content.policy_three')}}</h5>
              <ol class="policy-list-lv-1">
                <li>{{$t('front_end.a030.content.policy_thre_one')}}</li>
                <li>{{$t('front_end.a030.content.policy_three_two')}}</li>
              </ol>

              <h5
                id="policy-04"
                class="policy-text-title"
              >{{$t('front_end.a030.content.policy_four')}}</h5>
              <ol class="policy-list-lv-1">
                <li>{{$t('front_end.a030.content.policy_four_one')}}</li>
                <li>{{$t('front_end.a030.content.policy_four_two')}}</li>
                <li>
                  {{$t('front_end.a030.content.policy_four_three')}}
                  <br />
                  {{$t('front_end.a030.content.policy_four_three_br')}}
                </li>
                <li>{{$t('front_end.a030.content.policy_four_four')}}</li>
              </ol>

              <h5
                id="policy-05"
                class="policy-text-title"
              >{{$t('front_end.a030.content.policy_five')}}</h5>
              <ol class="policy-list-lv-1">
                <li>{{$t('front_end.a030.content.policy_five_one')}}</li>
                <li>
                  {{$t('front_end.a030.content.policy_five_two')}}
                  <ol class="policy-list-lv-2">
                    <li>
                      <span>{{$t('front_end.a030.content.policy_five_two_one_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_five_two_one')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_five_two_two_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_five_two_two')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_five_two_three_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_five_two_three')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_five_two_four_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_five_two_four')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_five_two_five_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_five_two_five')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_five_two_six_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_five_two_six')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_five_two_seven_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_five_two_seven')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_five_two_eight_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_five_two_eight')}}</span>
                    </li>
                  </ol>
                </li>
              </ol>

              <h5
                id="policy-06"
                class="policy-text-title"
              >{{$t('front_end.a030.content.policy_six')}}</h5>
              <ol class="policy-list-lv-1">
                <li>
                  {{$t('front_end.a030.content.policy_six_one')}}
                  <br />
                  {{$t('front_end.a030.content.policy_six_one_br')}}
                  <ol class="policy-list-lv-2">
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_one_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_one')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_two_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_two')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_three_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_three')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_four_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_four')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_five_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_five')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_six_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_six')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_seven_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_seven')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_eight_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_eight')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_nine_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_nine')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_ten_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_ten')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_eleven_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_eleven')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_twelve_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_twelve')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_thirteen_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_thirteen')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_fourteen_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_fourteen')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_fifteen_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_fifteen')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_sixteen_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_sixteen')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_one_seventeen_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_one_seventeen')}}</span>
                    </li>
                  </ol>
                </li>

                <li>
                  {{$t('front_end.a030.content.policy_six_two')}}
                  <br />
                  {{$t('front_end.a030.content.policy_six_two_br')}}
                  <ol class="policy-list-lv-2">
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_two_one_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_two_one')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_two_two_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_two_two')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_two_three_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_two_three')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_six_two_four_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_six_two_four')}}</span>
                    </li>
                  </ol>
                </li>

                <li>
                  {{$t('front_end.a030.content.policy_six_three')}}
                  <br />
                  {{$t('front_end.a030.content.policy_six_three_br')}}
                </li>

                <li>
                  {{$t('front_end.a030.content.policy_six_four')}}
                  <br />
                  {{$t('front_end.a030.content.policy_six_four_br_a')}}
                  <br />
                  {{$t('front_end.a030.content.policy_six_four_br_b')}}
                </li>
                <li>
                  {{$t('front_end.a030.content.policy_six_five')}}
                  <br />
                  {{$t('front_end.a030.content.policy_six_five_br_a')}}
                  <br />
                  {{$t('front_end.a030.content.policy_six_five_br_b')}}
                </li>
                <li>
                  {{$t('front_end.a030.content.policy_six_six')}}
                  <br />
                  {{$t('front_end.a030.content.policy_six_six_br_a')}}
                  <br />
                  {{$t('front_end.a030.content.policy_six_six_br_b')}}
                  <br />
                  {{$t('front_end.a030.content.policy_six_six_br_c')}}
                  <br />
                  {{$t('front_end.a030.content.policy_six_six_br_d')}}
                </li>
              </ol>

              <h5
                id="policy-07"
                class="policy-text-title"
              >{{$t('front_end.a030.content.policy_seven')}}</h5>
              <ol class="policy-list-lv-1">
                <li>{{$t('front_end.a030.content.policy_seven_one')}}</li>
                <li>{{$t('front_end.a030.content.policy_seven_two')}}</li>
              </ol>

              <h5
                id="policy-08"
                class="policy-text-title"
              >{{$t('front_end.a030.content.policy_eight')}}</h5>
              <ol class="policy-list-lv-1">
                <li>
                  {{$t('front_end.a030.content.policy_eight_one')}}
                  <ol class="policy-list-lv-2">
                    <li>
                      <span>{{$t('front_end.a030.content.policy_eight_one_one_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_eight_one_one')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_eight_one_two_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_eight_one_two')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_eight_one_three_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_eight_one_three')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_eight_one_four_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_eight_one_four')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_eight_one_five_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_eight_one_five')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_eight_one_six_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_eight_one_six')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_eight_one_seven_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_eight_one_seven')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_eight_one_eight_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_eight_one_eight')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_eight_one_nine_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_eight_one_nine')}}</span>
                    </li>
                    <li>
                      <span>{{$t('front_end.a030.content.policy_eight_one_ten_list')}}</span>
                      <span>{{$t('front_end.a030.content.policy_eight_one_ten')}}</span>
                    </li>
                  </ol>
                </li>
              </ol>

              <h5
                id="policy-09"
                class="policy-text-title"
              >{{$t('front_end.a030.content.policy_nine')}}</h5>
              <ol class="policy-list-lv-1">
                <li>{{$t('front_end.a030.content.policy_nine_one')}}</li>
                <li>{{$t('front_end.a030.content.policy_nine_two')}}</li>
              </ol>

              <h5
                id="policy-10"
                class="policy-text-title"
              >{{$t('front_end.a030.content.policy_ten')}}</h5>
              <ol class="policy-list-lv-1">
                <li>{{$t('front_end.a030.content.policy_ten_one')}}</li>
                <li>{{$t('front_end.a030.content.policy_ten_two')}}</li>
                <li>{{$t('front_end.a030.content.policy_ten_three')}}</li>
                <li>{{$t('front_end.a030.content.policy_ten_four')}}</li>
                <li>{{$t('front_end.a030.content.policy_ten_five')}}</li>
              </ol>

              <h5
                id="policy-11"
                class="policy-text-title"
              >{{$t('front_end.a030.content.policy_eleven')}}</h5>
              <span>{{$t('front_end.a030.content.policy_eleven_br')}}</span>
              <h5
                id="policy-12"
                class="policy-text-title mt-3"
              >{{$t('front_end.a030.content.policy_twelve')}}</h5>
              <span>{{$t('front_end.a030.content.policy_twelve_br')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content-footer-term container">
        <button
          class="content-footer-button col-md-4 col-8"
          @click="handleCheckTermAndNext"
          :disabled="!rawTerms"
        >{{$t('front_end.a030.button_check_next')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";
import { mapState, mapGetters } from "vuex";
var md5 = require("md5");

export default {
  name: "A030",
  data() {
    return {
      rawTerms: ""
    };
  },
  mounted() {
    this.$root.$on("header-back", this.backBtnHandle);
  },
  beforeDestroy() {
    this.$root.$off("header-back", this.backBtnHandle);
  },
  computed: {
    ...mapGetters(["userData"]),
    ...mapState({
      reOrder: state => state.userData.order.reOrder,
      templateId: state => state.userData.selected.template.templateId,
      newOrderNo: state => state.userData.order.orderNo,
      orderToken: state => state.userData.order.orderToken
    }),
    orderNo() {
      return this.reOrder;
    },
    urlConfirmPage() {
      // editor/CA-701/confirm
      //userData.selected.template.templateId
      let oh = ""
      if (this.userData?.order?.isConinueFromTemporary){
        oh = "?oh=" +  md5(this.newOrderNo)
      }
      return `/editor/${this.templateId}/confirm` + oh;
    }
  },
  methods: {
    backBtnHandle() {
      if (this.reOrder) {
        this.$router.push({
          name: "a110",
          params: {
            orderNo: this.orderToken
          }
        });
      } else {
        // this.$router.push({ name: "a025" });
        location.href = this.urlConfirmPage;
      }
    },
    async getTerm() {
      let r = await api.post(apiEndpoints.getTermsOfService, {});
      if (r && r.data && r.data.termsOfService) {
        this.rawTerms = r.data.termsOfService;
      }
    },
    handleCheckTermAndNext() {
      this.$store.commit("userData/SET_SELECTED", {
        accept_terms: true
      });

      this.$router.push({ name: "a035" });
    }
  },

  created() {
    this.getTerm();
  }
};
</script>

<style scoped src="../../assets/css/termCondition/termCondition.css"></style>
<style  >
.policy-list-lv-1 {
  padding-left: 33px;
}

.policy-list-lv-2 {
  padding-left: 0;
}

.policy-list-lv-2 li {
  display: flex;
}
.policy-text-title {
  font-weight: normal;
}
</style>
